<template>
  <section class="d-page">
    <div class="d-page__header">
      <v-row align="center">
        <v-col cols="12" sm="4" md="6">
          <div class="d-flex align-center">
            <slot name="heading"></slot>
          </div>
        </v-col>
        <v-col cols="12" sm="8" md="6" class="mt-3 mt-sm-0">
          <div
            class="d-flex align-center justify-start justify-sm-end flex-wrap"
          >
            <v-btn
              depressed
              v-if="hasSearch"
              @click="showSearchPanel = !showSearchPanel"
            >
              <v-icon left> mdi-magnify </v-icon>
              <span class="subtitle-2 text-none">{{
                $t("defaults.button.search-panel")
              }}</span>
              <v-avatar
                color="primary"
                size="20"
                class="ml-2"
                v-if="searchParamsCount > 0"
                ><span class="white--text">{{
                  searchParamsCount
                }}</span></v-avatar
              >
            </v-btn>
            <slot name="actions"></slot>
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="d-page__main">
      <v-expand-transition>
        <section
          class="d-page__search"
          v-if="hasSearch"
          v-show="showSearchPanel"
        >
          <v-form
            ref="searchForm"
            v-model="isFormValid"
            lazy-validation
            @submit.prevent="submitSearch"
          >
            <div class="d-page__search--body">
              <slot name="search"></slot>
            </div>
            <div class="d-page__search--footer">
              <v-row>
                <v-col cols="12">
                  <div class="d-flex align-center justify-end">
                    <v-btn
                      class="text-none body-2 font-weight-medium mr-3"
                      depressed
                      @click="clearSearch"
                      :loading="isSubmitting"
                    >
                      {{ $t("defaults.button.clear") }}
                    </v-btn>
                    <v-btn
                      type="submit"
                      color="primary"
                      class="text-none body-2 font-weight-medium"
                      depressed
                      :loading="isSubmitting"
                    >
                      {{ $t("defaults.button.search") }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-form>
        </section>
      </v-expand-transition>
      <div class="d-page__content" :class="contentClass">
        <slot name="content"></slot>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      isFormValid: true,
      isSubmitting: false,
      showSearchPanel: false,
    };
  },
  props: {
    title: String,
    contentClass: {
      type: String,
    },
    hasSearch: {
      type: Boolean,
      default: true,
    },
    searchParamsCount: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    clearSearch() {
      this.$emit("clearSearch");
    },
    submitSearch() {
      const isFormValid = this.$refs.searchForm.validate();
      if (isFormValid) {
        this.$emit("submitSearch");
      }
    },
    searchStarted() {
      this.isSubmitting = true;
    },
    searchFinished() {
      this.isSubmitting = false;
    },
  },
  created() {
    this.$eventBus.$on("searchStarted", this.searchStarted);
    this.$eventBus.$on("searchFinished", this.searchFinished);
  },
  beforeDestroy() {
    this.$eventBus.$off("searchStarted", this.searchStarted);
    this.$eventBus.$off("searchFinished", this.searchFinished);
  },
};
</script>

<style lang="scss">
.d-page {
  &__header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 12px 16px;
    border-bottom: 1px solid var(--v-gray-lighten2) !important;
    min-height: 60px;
  }
  &__search {
    margin: 16px;
    border: 1px solid var(--v-gray-lighten2);
    border-radius: 4px;

    &--body {
      padding: 16px 16px 4px 16px;
    }

    &--footer {
      padding: 12px 16px;
      border-top: 1px solid var(--v-gray-lighten2);
    }
  }

  &__content {
    overflow: auto;
    padding: 16px;
  }
}
</style>
